module.exports = ".wrapper .sidebar {\n\tdisplay: block;\n}\n\n.wrapper.wrapper-full-page .sidebar {\n\tdisplay: none;\n}\n\n.main-panel {\n\theight: auto;\n\tmax-height: unset;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = ./src/app/app.component.css
// module chunks = main